
import React, { Fragment } from 'react';

// Components

import SummaryItem from '../SummaryItem';

// Utils

import { normalizeNameOfPerson }  from '../../../../../../utils/normalize/normalizeNameOfPerson';
import { transformDropdownOptionsToObject } from '../../../../../../utils/normalize/transformDropdownOptionsToObject';
import { getYearInNumber } from '../../../../../../utils/dates/date.utils';

// Constants

import { DROPDOWN_OPTIONS } from '../../../../../../constants/ssap/hhmTypes/dropdownOptions';
import { reconcileAptcTypes } from '../../../../../../constants/ssap/hhmTypes/reconcileAptcTypes';
import { householdMemberTools } from '../../../../../../utils/tools/householdMemberTools';


const ReconcileAptcInfo = props => {

    const {
        independentTaxFiler,
        isRenewalFlow,
        isState,
        itfFeatureEnabled,
        member: {
            applicantGuid,
            personId
        },
        name,
        serverDate,
        taxHousehold,
        taxHousehold: {
            primaryTaxFilerPersonId
        }
    } = props;

    const isPTF = primaryTaxFilerPersonId === personId;

    if(itfFeatureEnabled) {
        if(!isPTF && !independentTaxFiler) {
            return null;
        }
    } else {
        if(!isPTF) {
            return null;
        }
    }

    const getAptcProps = (taxHousehold, applicantGuid) => {

        const member = householdMemberTools
            .extractFromHouseholdMembers(taxHousehold.householdMember)
            .getHhmByGuid(applicantGuid);

        const isPTF = taxHousehold.primaryTaxFilerPersonId === member.personId;

        return {
            previouslyReceivedAptc: member.previouslyReceivedAptc,
            reconciledAptc: itfFeatureEnabled && !isPTF
                ? member.reconciledAptc
                : taxHousehold.reconciledAptc,
            reconcileAptcOption: itfFeatureEnabled && !isPTF
                ? member.reconcileAptcOption
                : taxHousehold.reconcileAptcOption
        };
    };

    const RECONCILE_LIST = transformDropdownOptionsToObject(DROPDOWN_OPTIONS.RECONCILE_OPTIONS);

    const getReconcileAptcOption = (taxHousehold, applicantGuid) => {
        const {
            reconciledAptc,
            reconcileAptcOption
        } = getAptcProps(taxHousehold, applicantGuid);

        if (reconciledAptc === undefined || reconcileAptcOption === undefined) {
            return null;
        }

        if (reconcileAptcOption === reconcileAptcTypes.RECONCILIATION_NOT_ANSWERED) {
            return 'common.not_applicable';
        }

        return reconcileAptcOption === reconcileAptcTypes.NEVER_RECONCILED
            ? RECONCILE_LIST[reconcileAptcOption]
            : reconciledAptc;
    };

    const getPreviouslyReceivedAptc = (taxHousehold, applicantGuid) => {
        const {
            previouslyReceivedAptc
        } = getAptcProps(taxHousehold, applicantGuid);

        if (previouslyReceivedAptc === undefined) {
            return null;
        }

        return previouslyReceivedAptc;
    };

    const ReconciliationOptionSummaryItem = isRenewalFlow
        ? null
        : (
            <SummaryItem
                category = 'ssap.additional_info.summary.did_reconcile_aptc'
                value = { getReconcileAptcOption(taxHousehold, applicantGuid) }
                replacements = { {
                    currentYear: getYearInNumber(serverDate),
                    personName: normalizeNameOfPerson(name)
                } }
                desc = {
                    [
                        [
                            [
                                'DATA.TAX_HOUSEHOLD'
                            ],
                            getReconcileAptcOption,
                            [
                                applicantGuid
                            ]
                        ]
                    ]
                }
            />
        );

    const PreviouslyReceivedAptcSummaryItem = isRenewalFlow
        ? null
        : (
            <SummaryItem
                category = 'ssap.additional_info.summary.previously_received_aptc'
                value = { getPreviouslyReceivedAptc(taxHousehold, applicantGuid) }
                replacements = { {
                    personName: normalizeNameOfPerson(name)
                } }
                desc = {
                    [
                        [
                            [
                                'DATA.TAX_HOUSEHOLD'
                            ],
                            getPreviouslyReceivedAptc,
                            [
                                applicantGuid
                            ]
                        ]
                    ]
                }
            />
        );

    const getReconcileAptcInfo = () => {
        switch (true) {
            case isState.PA:
                switch (getPreviouslyReceivedAptc(taxHousehold, applicantGuid)) {
                    case true:
                        return (
                            <Fragment>
                                { PreviouslyReceivedAptcSummaryItem }
                                { ReconciliationOptionSummaryItem }
                            </Fragment>
                        );
                    default:
                        return PreviouslyReceivedAptcSummaryItem;
                }
            default:
                return ReconciliationOptionSummaryItem;
        }
    };

    return getReconcileAptcInfo();
};

export default ReconcileAptcInfo;